module.exports = __webpack_public_path__ + "static/media/05-Chelsea.456a4d20.mp4";